document.addEventListener('DOMContentLoaded', async function () {

  const popup = document.getElementById('shipping-notice-popup');

  if (!popup) return;

  const COOKIE_NAME = 'shipping_notice_closed';
  function setSessionCookie(name, value) {

    document.cookie =
      encodeURIComponent(name) +

      '=' +

      encodeURIComponent(value) +

      '; path=/; SameSite=Lax';
  }

  function getSessionCookie(name) {

    const cookies = document.cookie ? document.cookie.split('; ') : [];
    for (const c of cookies) {
      const parts = c.split('=');
      const k = parts[0];
      const v = parts[1];

      if (decodeURIComponent(k) === name) {
        return decodeURIComponent(v || '');
      }
    }
    return null;
  }

  //If already closed in this session
  if (getSessionCookie(COOKIE_NAME) === 'true') return;
  //Check utm_campaign
  const params = new URLSearchParams(window.location.search);
  const campaign = params.get('utm_campaign');
  if (campaign !== 'free_cwire_voucher') return;
  //Detect country
  async function getCountryCode() {
    try {
        const token = window.IPINFO_TOKEN;
        if (!token) return null;
        const res = await fetch(`https://ipinfo.io/json?token=${token}`, {
        method: 'GET',
        cache: 'no-store',
      });
      if (!res.ok) throw new Error('ipinfo failed');
      const data = await res.json();
      return (data.country || '').toUpperCase();
    } catch (e) {
      return null;
    }
  }
  const country_code = await getCountryCode();
  console.log("CountryCode", country_code);
  if (country_code !== 'CA') return;
  //Show popup
  popup.removeAttribute('hidden');
  popup.classList.add('is-active');

 
   const modal = popup.querySelector('[data-modal]');
const titleEl = popup.querySelector('#shipping-notice-title');

function setBackgroundInert(on) {
  Array.from(document.body.children).forEach((el) => {
    // if (el === popup || el.contains(popup)) return;
  if (
      el === popup ||
      el.contains(popup) ||
      el.id === 'consent_blackbar' ||        
      el.id === 'truste-consent-track' ||     
      el.id === 'truste-consent-content'      
    ) {
      return;
    }

    if (on) {
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
    } else {
      el.removeAttribute('inert');
      el.removeAttribute('aria-hidden');
    }
  });
}

function keepFocusInModal(e) {
  if (!popup.classList.contains('is-active')) return;
  const cookieRoot =
    document.getElementById('consent_blackbar') ||
    document.getElementById('truste-consent-track') ||
    document.getElementById('truste-consent-content');
  if (popup.contains(e.target)) return;
  if (cookieRoot && cookieRoot.contains(e.target)) return;
  focusAt(0);
}

// setBackgroundInert(true);
document.addEventListener('focusin', keepFocusInModal, true);

requestAnimationFrame(() => {
  titleEl?.focus({ preventScroll: true });
});

  


function getOrder() {
 const titleEl = popup.querySelector('#shipping-notice-title');
  const closeX = popup.querySelector('.modal__close');
  const btnEn = popup.querySelector('[data-lang-btn="en"]');
  const btnFr = popup.querySelector('[data-lang-btn="fr"]');
  const activeContent = popup.querySelector('.shipping-notice__content.is-active');
  const emailEl = activeContent?.querySelector('a[href^="mailto:"]');
  const closeCta = popup.querySelector('[data-shipping-btn]');
  return [titleEl, closeX, btnEn, btnFr, emailEl, closeCta].filter(Boolean);

}

let modalOpen = true;

let firstTabCaptured = false;

// Show outline ONLY after user hits Tab
popup.classList.remove('user-is-tabbing');

function isInsidePopup(node) {
  return node && popup.contains(node);
}

function focusAt(i) {
  const order = getOrder();
  const el = order[i];
  if (el) el.focus({ preventScroll: true });
}

function onDocKeyDown(e) {
  if (!modalOpen) return;
  if (e.key !== 'Tab') return;

  e.preventDefault();

  popup.classList.add('user-is-tabbing');


  const active = document.activeElement;

  // If focus is outside modal (behind popup), bring back to Title
  if (!isInsidePopup(active)) {
    focusAt(0);
    return;
  }

  const order = getOrder();
  const idx = order.indexOf(active);

  if (idx === -1) {
    focusAt(0);
    return;
  }

  let next = e.shiftKey ? idx - 1 : idx + 1;
  if (next < 0) next = order.length - 1;
  if (next >= order.length) next = 0;
  focusAt(next);

}



document.addEventListener('keydown', onDocKeyDown, true);

  function closePopup() {
  modalOpen = false;

  popup.classList.remove('is-active');
  popup.setAttribute('hidden', '');
  setSessionCookie(COOKIE_NAME, 'true');

  setBackgroundInert(false);
  document.removeEventListener('focusin', keepFocusInModal, true);
  }

  popup.querySelectorAll('[data-close-shipping-notice]').forEach((btn) => {
    btn.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

  // Language toggle
  const title = popup.querySelector('#shipping-notice-title');
  const btnEn = popup.querySelector('[data-lang-btn="en"]');
  const btnFr = popup.querySelector('[data-lang-btn="fr"]');
  const enContent = popup.querySelector('[data-lang-content="en"]');
  const frContent = popup.querySelector('[data-lang-content="fr"]');
  const actionBtn = popup.querySelector('[data-shipping-btn]');


  function setLang(lang) {
    const isEn = lang === 'en';
    enContent?.classList.toggle('is-active', isEn);
    frContent?.classList.toggle('is-active', !isEn);
    btnEn?.classList.toggle('is-active', isEn);
    btnFr?.classList.toggle('is-active', !isEn);

// Showing title and button as language

    if (title)
      title.textContent = isEn ? 'Shipping Notice' : 'Avis de livraison';
    if (actionBtn)
      actionBtn.textContent = isEn ? 'CLOSE' : 'FERMER';
       firstTabCaptured = false;

  }


  const htmlLang = (document.documentElement.lang || 'en').toLowerCase();

  setLang(htmlLang.startsWith('fr') ? 'fr' : 'en');

  btnEn?.addEventListener('click', (e) => {
    e.preventDefault();
    setLang('en');
    requestAnimationFrame(() => e.currentTarget.focus({ preventScroll: true }));
     firstTabCaptured = true;
  });

  btnFr?.addEventListener('click', (e) => {
    e.preventDefault();
    setLang('fr');
    requestAnimationFrame(() => e.currentTarget.focus({ preventScroll: true }));
    firstTabCaptured = true;

  });

});

